import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ProductsFilter = ({
    products = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --products'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='products'
        options={products}
        placeholder='Product'
        search
        setValue={restoreFilterValues(filters, 'products')}
    />
);

ProductsFilter.propTypes = {
    products: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
